module.exports = __webpack_public_path__ + "static/media/BH.2366200b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/BH.svg
// module id = 2112
// module chunks = 7